var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS3P2BImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 104,
    viewBox: "0 0 100 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1045 56.6854L99.5173 87.1034L64.8955 103.453L0.482683 73.0351L17.7941 60.5078L35.1045 56.6854Z",
    fill: "url(#paint0_linear_1351_27898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1045 56.6514L99.5173 87.0694L82.2064 90.2647L64.8955 103.419L0.482666 73.0011L17.794 60.4738L35.1045 56.6514Z",
    fill: "url(#paint1_linear_1351_27898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5351 4.84747L85.9682 35.275L99.5079 87.0706L36.2248 57.2189L21.5351 4.84747Z",
    fill: "url(#paint2_linear_1351_27898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4933 4.84852L85.9264 35.276L64.9164 103.5L0.483342 73.0727L21.4933 4.84852Z",
    fill: "url(#paint3_linear_1351_27898)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.432 4.76709L86.1429 34.8932L70.6114 85.5798L5.50478 56.4511L21.432 4.76709Z",
    fill: "#7F0505"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.813 4.76709L83.5239 34.8932L67.9924 85.5798L2.88582 56.4511L18.813 4.76709Z",
    fill: "url(#paint4_linear_1351_27898)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4674 4.77148H18.8469L21.4674 6.01452V4.77148Z",
    fill: "#7F0505"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5939 85.5684H67.9836L68.3027 84.5244L70.5939 85.5684Z",
    fill: "#7F0505"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.584 29.9399C66.584 28.1498 67.1693 26.2759 68.0851 24.7068C69.0006 23.1383 70.218 21.9143 71.5114 21.3035C72.8047 20.6927 74.0222 20.7669 74.9376 21.4708C75.8534 22.175 76.4388 23.4961 76.4388 25.2861C76.4388 26.8228 76.0074 28.4213 75.3058 29.8358L76.2503 30.2865C77.1904 28.5138 77.7461 26.531 77.7461 24.6687C77.7461 22.6331 77.0821 21.0808 75.978 20.2318C74.8735 19.3825 73.3004 19.2239 71.5114 20.0687C69.7224 20.9135 68.1493 22.5579 67.0448 24.4504C65.9406 26.3421 65.2766 28.5217 65.2766 30.5573C65.2766 32.5928 65.9406 34.1452 67.0448 34.9942C68.1493 35.8435 69.7224 36.0021 71.5114 35.1573C71.6543 35.0897 71.7959 35.0171 71.936 34.9397C72.1109 34.3211 71.798 34.0351 71.4212 33.964C70.1615 34.5295 68.9793 34.4427 68.0851 33.7552C67.1693 33.051 66.584 31.7299 66.584 29.9399Z",
    fill: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5664 27.1381C60.5664 25.3481 61.1517 23.4742 62.0676 21.905C62.983 20.3366 64.2004 19.1125 65.4938 18.5017C66.7872 17.891 68.0046 17.9652 68.92 18.6691C69.8358 19.3732 70.4212 20.6943 70.4212 22.4843C70.4212 24.0211 69.9898 25.6196 69.2883 27.034L70.2327 27.4847C71.1728 25.712 71.7286 23.7293 71.7286 21.867C71.7286 19.8314 71.0645 18.279 69.9604 17.43C68.8559 16.5808 67.2828 16.4221 65.4938 17.267C63.7048 18.1118 62.1317 19.7562 61.0272 21.6486C59.9231 23.5404 59.259 25.7199 59.259 27.7555C59.259 29.7911 59.9231 31.3435 61.0272 32.1924C62.1317 33.0417 63.7048 33.2003 65.4938 32.3555C65.6368 32.288 65.7783 32.2154 65.9184 32.1379C66.0933 31.5193 65.7804 31.2334 65.4036 31.1623C64.1439 31.7277 62.9617 31.6409 62.0676 30.9534C61.1517 30.2492 60.5664 28.9281 60.5664 27.1381Z",
    fill: "#1E1E1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5959 13.7314C31.5959 11.9414 32.1813 10.0674 33.0971 8.49829C34.0125 6.92981 35.23 5.70576 36.5233 5.09498C37.8167 4.48421 39.0341 4.55845 39.9496 5.26233C40.8654 5.96651 41.4507 7.28758 41.4507 9.0776C41.4507 10.6143 41.0193 12.2128 40.3178 13.6273L41.2622 14.078C42.2023 12.3053 42.7581 10.3225 42.7581 8.46023C42.7581 6.42464 42.0941 4.87226 40.9899 4.02329C39.8854 3.17402 38.3123 3.01541 36.5233 3.86023C34.7344 4.70504 33.1612 6.34941 32.0567 8.24186C30.9526 10.1336 30.2886 12.3132 30.2886 14.3488C30.2886 16.3843 30.9526 17.9367 32.0567 18.7857C33.1612 19.635 34.7344 19.7936 36.5233 18.9488C36.6663 18.8812 36.8079 18.8086 36.948 18.7312C37.1229 18.1126 36.8099 17.8266 36.4332 17.7555C35.1735 18.321 33.9912 18.2342 33.0971 17.5467C32.1813 16.8425 31.5959 15.5214 31.5959 13.7314Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5774 10.9306C25.5774 9.14057 26.1627 7.26666 27.0786 5.69751C27.994 4.12903 29.2114 2.90497 30.5048 2.2942C31.7981 1.68343 33.0156 1.75767 33.931 2.46155C34.8468 3.16573 35.4322 4.4868 35.4322 6.27682C35.4322 7.81353 35.0008 9.41207 34.2992 10.8265L35.2437 11.2772C36.1838 9.50451 36.7395 7.52174 36.7395 5.65944C36.7395 3.62386 36.0755 2.07147 34.9714 1.22251C33.8669 0.373239 32.2938 0.214626 30.5048 1.05944C28.7158 1.90426 27.1427 3.54863 26.0382 5.44108C24.934 7.33286 24.27 9.51239 24.27 11.548C24.27 13.5836 24.934 15.1359 26.0382 15.9849C27.1427 16.8342 28.7158 16.9928 30.5048 16.148C30.6477 16.0805 30.7893 16.0078 30.9294 15.9304C31.1043 15.3118 30.7914 15.0258 30.4146 14.9547C29.1549 15.5202 27.9727 15.4334 27.0786 14.7459C26.1627 14.0417 25.5774 12.7206 25.5774 10.9306Z",
    fill: "#1E1E1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7361 37.6778L30.3638 43.9021C27.545 46.2819 27.1891 50.4963 29.5689 53.3151C31.9488 56.1339 36.1631 56.4897 38.982 54.1099L46.9214 47.4069C48.4874 46.0848 50.8287 46.2825 52.1508 47.8484C53.473 49.4144 53.2753 51.7558 51.7093 53.0779L44.1433 59.4656C42.5604 58.5384 40.5007 58.6556 39.0192 59.9065C37.14 61.493 36.9027 64.3025 38.4893 66.1818C40.0759 68.0611 42.8854 68.2982 44.7646 66.7117C46.2461 65.4609 46.7071 63.4499 46.0585 61.734L53.6244 55.3463C56.4432 52.9664 56.7991 48.7521 54.4192 45.9333C52.0394 43.1145 47.8251 42.7586 45.0062 45.1385L37.0668 51.8415C35.5008 53.1636 33.1595 52.9659 31.8374 51.3999C30.5152 49.8339 30.7129 47.4926 32.2789 46.1705L39.6513 39.9462L42.524 43.3488L44.3647 34.0242L34.8634 34.2752L37.7361 37.6778Z",
    fill: "#EDBA60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_27898",
    x1: 50,
    y1: 4.76709,
    x2: 83.9627,
    y2: 151.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_27898",
    x1: 50,
    y1: 4.76709,
    x2: 50,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.574056,
    stopColor: "#8F7D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6544"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_27898",
    x1: 50,
    y1: 4.76709,
    x2: 50,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D341A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1351_27898",
    x1: 50,
    y1: 4.76709,
    x2: 50,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1351_27898",
    x1: 43.2049,
    y1: 15.8533,
    x2: 20.1771,
    y2: 64.6169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB4949"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS3P2BImg3);
export default __webpack_public_path__ + "static/media/HomeS3P2BImg3.9976246cb39dd5bc390ae79e9e5f6ea7.svg";
export { ForwardRef as ReactComponent };